import React, { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const currentUser = authService.getCurrentUser();
    if (currentUser) {
      setUser(currentUser);
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    const response = await authService.login(username, password);
    setUser(response.user);
    return response;
  };

  const logout = () => {
    authService.logout();
    setUser(null);
  };

  // Permission helpers
  const canManageUsers = () => {
    return user && (user.role === 'app-manager' || user.role === 'admin');
  };

  const canManageSymbols = () => {
    return user && (user.role === 'app-manager' || user.role === 'admin');
  };

  const isAppManager = () => {
    return user && user.role === 'app-manager';
  };

  const value = {
    user,
    login,
    logout,
    isAuthenticated: !!user,
    loading,
    canManageUsers,
    canManageSymbols,
    isAppManager,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
